module.exports = __webpack_public_path__ + "static/media/sa9.f69770dd.jpg";